module.exports = __webpack_public_path__ + "static/media/burrito.47c33a13.svg";